import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"display":"block","width":"900px"} }

import { ElOption, ElSelect, ElTable, FormInstance, FormRules } from 'element-plus'
import { computed, onMounted, reactive, ref } from 'vue'
import { DataPointItem } from '@/store/profile.interface'
import { Plus, Delete, CopyDocument } from '@element-plus/icons-vue'
import { BACObjectType, BACObjectTypeMap, EngineeringUnits } from '@/store/bactype'
import { NewProfileStore } from '@/store/newProfileStore'
import BlockTitle from './BlockTitle.vue'

interface SelectOptions {
  name: string,
  value: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DataPointEditor',
  setup(__props) {

const store = new NewProfileStore()

const data = computed(() => store.DataPoints())

const newDataPointForm = ref<FormInstance>()
const disableNewDataPoint = ref<boolean>(false)

const ListBACObjTypeOptions = () :SelectOptions[] => {
  return Object.values(BACObjectType).map(type => {
    return {
      name: type,
      value: type
    }
  })
}

const isWritable = (type: BACObjectTypeMap[keyof BACObjectTypeMap]):boolean => {
  switch (type) {
    case BACObjectType.ANALOG_VALUE:
    case BACObjectType.ANALOG_OUTPUT:
    case BACObjectType.BINARY_OUTPUT:
    case BACObjectType.BINARY_VALUE:
    case BACObjectType.OCTET_STRING_VALUE:return true
    default: return false
  }
}

const ListUnitsOptions = (): SelectOptions[] => {
  return Object.values(EngineeringUnits).map(type => {
    return {
      name: type,
      value: type
    }
  })
}

const BACObjTypeOptions = ref<SelectOptions[]>(ListBACObjTypeOptions())
const BACUnitsOptions = ref<SelectOptions[]>(ListUnitsOptions())

const newDataPoint = reactive<DataPointItem>({
  channel: 1,
  name: '',
  type: 'AnalogInputObject',
  covIncrement: 0,
  fport: undefined,
  updateInterval: 60,
  units: undefined
})

const DataPointFormRules = ref<FormRules<DataPointItem>>({
  name: [{
    type: 'string', min: 1, max: 32, required: true, pattern: /^[a-zA-Z0-9_-\s]{1,32}$/, trigger: 'blur'
  }],
  fport: [{
    type: 'integer', min: 1, max: 224, required: true
  }],
  updateInterval: [{
    type: 'integer', min: 1, max: 86400, required: true
  }]
})

const OnAddDataPoint = () => {
  newDataPointForm.value?.validate((isvalid, item) => {
    if (isvalid) {
      store.PushDataPoint({ ...newDataPoint }).then(() => {
        ResetNewDataPointForm()
      }).catch(reason => {
        console.log(reason)
      })
    }
  })
}

const OnDeleteDataPoint = (channel:number) => {
  store.DeleteDataPoint(channel).then(() => {
    ResetNewDataPointForm()
  }).catch(err => {
    console.log(err)
  })
}
const ResetNewDataPointForm = () => {
  const channelId = store.GetNextChannelID()
  if (channelId === undefined) {
    disableNewDataPoint.value = true
    return
  } else {
    disableNewDataPoint.value = false
  }

  newDataPoint.channel = channelId
  newDataPoint.name = ''
  newDataPoint.covIncrement = 0
  newDataPoint.type = BACObjectType.ANALOG_INPUT
}

const OnDuplicate = (item: DataPointItem) => {
  const New = { ...item }
  New.channel = store.GetNextChannelID()
  store.PushDataPoint({ ...New }).then(() => {
    ResetNewDataPointForm()
  }).catch(reason => {
    console.log(reason)
  })
}

onMounted(() => {
  ResetNewDataPointForm()
})

return (_ctx: any,_cache: any) => {
  const _component_ElInputNumber = _resolveComponent("ElInputNumber")!
  const _component_ElFormItem = _resolveComponent("ElFormItem")!
  const _component_ElInput = _resolveComponent("ElInput")!
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_ElForm = _resolveComponent("ElForm")!
  const _component_ElTableColumn = _resolveComponent("ElTableColumn")!
  const _component_ElIcon = _resolveComponent("ElIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BlockTitle, {
      title: "Data Points",
      description: "Edit the data points supported by the device to ensure proper conversion into BACnet Data Objects by the BACnet gateway."
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ElForm, {
        ref_key: "newDataPointForm",
        ref: newDataPointForm,
        rules: DataPointFormRules.value,
        model: newDataPoint,
        "label-width": "auto",
        "label-position": "left",
        style: {"width":"600px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ElFormItem, { label: "Channel" }, {
            default: _withCtx(() => [
              _createVNode(_component_ElInputNumber, {
                modelValue: newDataPoint.channel,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newDataPoint.channel) = $event)),
                readonly: "true"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_ElFormItem, {
            label: "Name",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ElInput, {
                modelValue: newDataPoint.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newDataPoint.name) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_ElFormItem, { label: "BACnet Object Type" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElSelect), {
                modelValue: newDataPoint.type,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newDataPoint.type) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(BACObjTypeOptions.value, (opt) => {
                    return (_openBlock(), _createBlock(_unref(ElOption), {
                      key: opt.value,
                      value: opt.value,
                      label: opt.name
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_ElFormItem, { label: "Engineer Unit" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElSelect), {
                modelValue: newDataPoint.units,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newDataPoint.units) = $event)),
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(BACUnitsOptions.value, (opt) => {
                    return (_openBlock(), _createBlock(_unref(ElOption), {
                      key: opt.value,
                      value: opt.value,
                      label: opt.name
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_ElFormItem, { label: "CoV Increment" }, {
            default: _withCtx(() => [
              _createVNode(_component_ElInputNumber, {
                modelValue: newDataPoint.covIncrement,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newDataPoint.covIncrement) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (isWritable(newDataPoint.type))
            ? (_openBlock(), _createBlock(_component_ElFormItem, {
                key: 0,
                label: "Downlink FPort",
                prop: "fport"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElInputNumber, {
                    modelValue: newDataPoint.fport,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newDataPoint.fport) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_ElFormItem, {
            label: "Update Interval (Seconds)",
            prop: "updateInterval"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ElInputNumber, {
                modelValue: newDataPoint.updateInterval,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newDataPoint.updateInterval) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_ElFormItem, { label: " " }, {
            default: _withCtx(() => [
              _createVNode(_component_ElButton, {
                type: "primary",
                icon: _unref(Plus),
                onClick: _cache[7] || (_cache[7] = ($event: any) => (OnAddDataPoint())),
                disabled: disableNewDataPoint.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Add BACnet Object")
                ]),
                _: 1
              }, 8, ["icon", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"]),
      _createVNode(_unref(ElTable), {
        data: data.value,
        style: {"width":"900px"},
        stripe: "",
        "table-layout": "auto"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ElTableColumn, { type: "selection" }),
          _createVNode(_component_ElTableColumn, {
            prop: "channel",
            label: "Channel",
            width: "80"
          }),
          _createVNode(_component_ElTableColumn, {
            prop: "name",
            label: "Name",
            width: "250"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_ElInput, {
                modelValue: scope.row.name,
                "onUpdate:modelValue": ($event: any) => ((scope.row.name) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_ElTableColumn, {
            prop: "type",
            label: "Object Type"
          }),
          _createVNode(_component_ElTableColumn, {
            prop: "covIncrement",
            label: "Cov Increment"
          }),
          _createVNode(_component_ElTableColumn, {
            prop: "fport",
            label: "Downlink FPort"
          }),
          _createVNode(_component_ElTableColumn, {
            prop: "updateInterval",
            label: "Update Interval"
          }),
          _createVNode(_component_ElTableColumn, {
            prop: "units",
            label: "Unit"
          }),
          _createVNode(_component_ElTableColumn, {
            label: "",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_ElIcon, {
                onClick: ($event: any) => (OnDeleteDataPoint(scope.row.channel)),
                style: {"margin-right":"8px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Delete))
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_ElIcon, {
                onClick: ($event: any) => (OnDuplicate(scope.row))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(CopyDocument))
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ])
  ], 64))
}
}

})